/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const LockIcon = /*#__PURE__*/ createSvgIcon(
  'LockIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.494 18c-.413 0-.765-.147-1.056-.44A1.45 1.45 0 014 16.5v-8c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44H6V5c0-1.107.39-2.05 1.171-2.83C7.952 1.39 8.897 1 10.005 1s2.05.39 2.828 1.17C13.611 2.95 14 3.893 14 5v2h.5c.412 0 .766.147 1.06.44.293.294.44.647.44 1.06v8c0 .413-.147.766-.44 1.06-.295.293-.648.44-1.06.44H5.493zm.006-1.5h9v-8h-9v8zm4.504-2.5c.414 0 .767-.147 1.059-.442.291-.294.437-.649.437-1.062 0-.414-.147-.767-.442-1.059A1.456 1.456 0 009.996 11c-.414 0-.767.147-1.059.442a1.456 1.456 0 00-.437 1.062c0 .414.147.767.442 1.059.294.291.649.437 1.062.437zM7.5 7h5V5c0-.694-.243-1.285-.73-1.77A2.41 2.41 0 0010 2.5a2.41 2.41 0 00-1.77.73A2.41 2.41 0 007.5 5v2z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default LockIcon;
